import React from "react";
import { Link, useLocation } from "react-router-dom";
import DashboardIcon from "@mui/icons-material/Dashboard";
import GroupIcon from "@mui/icons-material/Group";
import PersonAddIcon from "@mui/icons-material/PersonAdd";
import ChatBubbleIcon from "@mui/icons-material/ChatBubble";
import BuildIcon from "@mui/icons-material/Build";
import UpdateIcon from "@mui/icons-material/Update";
import RestaurantIcon from "@mui/icons-material/Restaurant";
import { useSelector } from "react-redux";

const SideBar = () => {
  const location = useLocation();
  const { profileData } = useSelector((state) => state.profile);

  const menuItems = [
    { icon: <DashboardIcon />, label: "Dashboard", path: "/dashboard" },
    { icon: <GroupIcon />, label: "Clients", path: "/clients" },
    { icon: <PersonAddIcon />, label: "Leads", path: "/leads" },
    { icon: <ChatBubbleIcon />, label: "Messenger", path: "/messenger" },
    { icon: <BuildIcon />, label: "Toolbox", path: "/toolbox" },
    { icon: <UpdateIcon />, label: "Latest Updates", path: "/updates" },
    // { icon: <RestaurantIcon />, label: "Recipe", path: "/recipe" },
  ];

  // Show the Recipe only if isAdmin is true
  if (profileData?.isAdmin) {
    menuItems.push({
      icon: <RestaurantIcon />,
      label: "Recipe",
      path: "/recipe",
    });
  }

  return (
    <aside className="sidebar">
      <nav className="sidebar__nav">
        <ul>
          {menuItems.map((item) => (
            <li key={item.label} className="p-2.5">
              <Link
                to={item.path}
                className={`sidebar__nav-item ${
                  location.pathname.startsWith(item.path) ? "active" : ""
                }`}
              >
                <div className="icon-wrapper">{item.icon}</div>
                <span className="icon-label">{item.label}</span>
              </Link>
            </li>
          ))}
        </ul>
      </nav>
    </aside>
  );
};

export default SideBar;
